import React, { useEffect, useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import SideMessage from '../../../components/SideMessage';
import GetProjectPlotById from '../../../APIs/ProjectPlotDetails/GetProjectPlotById';
import InsertPlotSequence from '../../../APIs/DefineSequencing/InsertPlotSequence';
import GetPlotSequenceByPlotSpecificationId from '../../../APIs/DefineSequencing/GetPlotSequenceByPlotSpecificationId';
import UpdatePlotSequence from '../../../APIs/DefineSequencing/UpdatePlotSequence';

export default function DefineSequencing() {

  const projectId = JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId;

  let { id } = useParams();

  const [sendForm, setSendForm] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [plotTypes, setPlotTypes] = useState([
    {
      id: 1,
      plotType: "Sea View"
    },
    {
      id: 2,
      plotType: "River View"
    },
    {
      id: 3,
      plotType: "Road Side"
    },
    {
      id: 4,
      plotType: "Corner"
    }
  ])

  const [plotSpecificationForm, stePlotSpecificationForm] = useState({
    id: id,
    projectId: 0,
    dimensions: "",
    area: 0,
    noOfPlots: 0,
    perPlotCost: 0,
    userId: 0,
  });

  let [sideToaster, setSideToaster] = useState({
    show: 0,
    message: '',
    type: ''
  });

  let [loader, setLoader] = useState(0);

  const getPlotDetailsById = async (id) => {

    try {

      setLoader(1);

      let response = await GetProjectPlotById(id);

      if (response?.status === 1) {

        let data = response?.responseValue;

        let responsePlotNumber = await GetPlotSequenceByPlotSpecificationId(id);

        stePlotSpecificationForm(data);

        let noOfPlots = parseInt(data?.noOfPlots) || 0;

        if (responsePlotNumber?.status === 1) {

          if (responsePlotNumber?.responseValue?.length > 0) {
            setIsUpdate(true);
          }

          let plotsArray = Array.from(
            {
              length: noOfPlots - responsePlotNumber.responseValue.length
            },
            () => ({
              id: 0,
              projectId: data?.projectId,
              plotdimmensions: data?.dimensions,
              plotSpecificationId: id,

              plotSequenceNumber: '',
              plotNumber: '',

              isCommercial: false,
              plotTypes: [],
              extraPrice: '',
              extraPriceCommercial: '',
              // plotdimmensions:'',

              isUpdate: false,
              userId: window.userId
            })
          );

          responsePlotNumber.responseValue.map((plotNumber) => {

            plotsArray.push({
              id: plotNumber?.id,
              projectId: plotNumber?.projectId,
              // dimensions: data?.dimensions,
              plotSpecificationId: plotNumber?.plotSpecificationId,

              plotSequenceNumber: plotNumber?.plotSequenceNumber || '',
              plotNumber: plotNumber?.plotNumber || '',

              isCommercial: plotNumber?.isCommercial || false,

              plotTypes: plotNumber?.plotTypes
                ? plotNumber.plotTypes.split(',')
                : [],

              extraPrice: plotNumber?.extraPrice || '',
              extraPriceCommercial: plotNumber?.extraPriceCommercial || '',
              // plotdimmensions:plotNumber?.plotdimmensions||'',
              plotdimmensions:
                plotNumber?.plotdimmensions ||
                data?.dimensions ||
                '',

              isUpdate: true,
              userId: window.userId
            })
          })
          console.log("plotsArray---", plotsArray, data)
          setSendForm(plotsArray)

        }
        else {

          let plotsArray = Array.from(
            { length: noOfPlots },
            () => ({
              id: 0,
              projectId: data?.projectId,
              plotdimmensions: data?.dimensions,
              plotSpecificationId: id,

              plotSequenceNumber: '',
              plotNumber: '',

              isCommercial: false,
              plotTypes: [],
              extraPrice: '',
              extraPriceCommercial: '',

              isUpdate: false,
              userId: window.userId
            })
          );

          setSendForm(plotsArray)
        }

      }
      else {

        setSideToaster({
          show: 1,
          message: response.responseValue,
          type: 'Alert'
        })
      }

    }
    catch (e) {

      setSideToaster({
        show: 1,
        message: e.message,
        type: 'Alert'
      })
    }
    finally {
      setLoader(0);
    }
  }

  const handleChange = (e, index) => {

    const { name, value, checked } = e.target;

    const updated = [...sendForm];

    if (name === "isCommercial") {

      updated[index].isCommercial = checked;

      if (!checked) {
        updated[index].extraPriceCommercial = '';
      }

    }
    // else if (name === "plotTypes") {

    //   const selected = updated[index].plotTypes || [];

    //   if (checked) {
    //     updated[index].plotTypes = [...selected, value];
    //   }
    //   else {
    //     updated[index].plotTypes = selected.filter(x => x !== value);
    //     updated[index].plotTypes = [];
    //     updated[index].extraPrice = '';
    //   }

    // }
    else if (name === "plotTypes") {

      const selected = updated[index].plotTypes || [];

      if (checked) {

        updated[index].plotTypes = [...selected, value];

      } else {

        updated[index].plotTypes =
          selected.filter(x => x !== value);

        // clear extra price only if no plot type left
        if (updated[index].plotTypes.length === 0) {
          updated[index].extraPrice = '';
        }
      }
    }
    else if (name === "plotdimmensions") {

    updated[index][name] = value
      .replace(/\s*\*\s*/g, "*")
      .trim();

  }
    else {

      updated[index][name] = value;
    }

    setSendForm(updated);
  };

  const validateForm = (data) => {

    // only rows user touched
    const filledRows = data.filter(item =>

      item.plotSequenceNumber !== '' ||
      item.plotNumber?.trim() ||
      item.isCommercial ||
      item.extraPrice ||
      item.extraPriceCommercial ||
      (item.plotTypes && item.plotTypes.length > 0)

    );

    // duplicate validation
    const numbers = filledRows
      .map(item => item.plotSequenceNumber)
      .filter(num => num !== '');

    const hasDuplicates =
      numbers.length !== new Set(numbers).size;

    if (hasDuplicates) {

      return {
        valid: false,
        message: 'Please Remove Duplicate Plot Sequence Number'
      };
    }

    for (let item of filledRows) {

      // sequence required
      if (
        item.plotSequenceNumber === '' ||
        item.plotSequenceNumber === null ||
        item.plotSequenceNumber === undefined
      ) {

        return {
          valid: false,
          message: 'Plot Sequence Number is required.'
        };
      }

      // plot number required
      if (!item.plotNumber || !item.plotNumber.trim()) {

        return {
          valid: false,
          message: 'Plot Number is required.'
        };
      }

      // commercial validation
      // if (item.isCommercial) {

      //   if (!item.plotTypes || item.plotTypes.length === 0) {

      //     return {
      //       valid: false,
      //       message: 'Select at least one Plot Type for Commercial plots.'
      //     };
      //   }

      //   if (
      //     item.extraPrice === '' ||
      //     item.extraPrice === null ||
      //     Number(item.extraPrice) <= 0
      //   ) {

      //     return {
      //       valid: false,
      //       message: 'Extra Price is required for Commercial plots.'
      //     };
      //   }
      // }
      // Commercial price validation
      if (item.isCommercial) {

        if (
          item.extraPriceCommercial === '' ||
          item.extraPriceCommercial === null ||
          Number(item.extraPriceCommercial) <= 0
        ) {

          return {
            valid: false,
            message: 'Commercial Extra Price is required.'
          };
        }
      }

      // Plot type validation
      if (item.plotTypes && item.plotTypes.length > 0) {

        if (
          item.extraPrice === '' ||
          item.extraPrice === null ||
          Number(item.extraPrice) <= 0
        ) {

          return {
            valid: false,
            message: 'Plot Type Extra Price is required.'
          };
        }
      }
    }

    return { valid: true };
  };

  const preparePayload = () => {

    return sendForm
      .filter(item =>

        item.plotSequenceNumber !== '' ||
        item.plotNumber?.trim() ||
        item.isCommercial ||
        item.extraPriceCommercial ||
        item.extraPrice

      )
      .map(item => ({
        ...item,
        extraPriceCommercial: item.extraPriceCommercial || 0,
        extraPrice: item.extraPrice || 0,
        plotTypes: item.plotTypes?.join(",")
      }));
  }

  const handleOnSave = async () => {

    try {

      setLoader(1);

      const validation = validateForm(sendForm);

      if (!validation.valid) {

        return setSideToaster({
          show: 1,
          message: validation.message,
          type: 'alert'
        });
      }

      const payload = preparePayload();

      const response = await InsertPlotSequence(payload);

      if (response?.status === 1) {

        getPlotDetailsById(id);

        setSideToaster({
          show: 1,
          message: 'Save Data.',
          type: 'success'
        });
        window.history.back();
      }
      else {

        setSideToaster({
          show: 1,
          message: response?.message,
          type: 'alert'
        });
      }

    }
    catch (e) {

      setSideToaster({
        show: 1,
        message: e.message,
        type: 'alert'
      });
    }
    finally {
      setLoader(0);
    }
  };

  const handleUpdate = async () => {

    try {

      setLoader(1);

      const validation = validateForm(sendForm);

      if (!validation.valid) {

        return setSideToaster({
          show: 1,
          message: validation.message,
          type: 'alert'
        });
      }

      const payload = preparePayload();

      const response = await UpdatePlotSequence(payload);

      if (response?.status === 1) {

        getPlotDetailsById(id);

        setSideToaster({
          show: 1,
          message: 'Update Data.',
          type: 'success'
        });
        window.history.back();
      }
      else {

        setSideToaster({
          show: 1,
          message: response?.message,
          type: 'alert'
        });
      }

    }
    catch (e) {

      setSideToaster({
        show: 1,
        message: e.message,
        type: 'alert'
      });
    }
    finally {
      setLoader(0);
    }
  };
  const calculateAverageCost = () => {

    if (!sendForm?.length) {
      return plotSpecificationForm?.perPlotCost || 0;
    }

    const totalExtra = sendForm.reduce((sum, item) => {

      let commercial = Number(item.extraPriceCommercial || 0);
      let plotType = Number(item.extraPrice || 0);

      return sum + commercial + plotType;

    }, 0);

    return Number(plotSpecificationForm?.perPlotCost || 0) + totalExtra;
  };
  // const calculateAverageCost = () => {

  //   const commercialPlots = sendForm.filter(
  //     item =>
  //       item.isCommercial &&
  //       item.extraPrice &&
  //       item.extraPriceCommercial &&
  //       Number(item.extraPrice) > 0 && Number(item.extraPriceCommercial) > 0
  //   );

  //   if (commercialPlots.length === 0) {
  //     return plotSpecificationForm?.perPlotCost || 0;
  //   }

  //   const totalExtraPrice = commercialPlots.reduce(
  //     (sum, item) => sum + Number(item.extraPrice),
  //     0
  //   );

  //   const averageExtraPrice =
  //     totalExtraPrice / commercialPlots.length;

  //   return (
  //     Number(plotSpecificationForm?.perPlotCost || 0) +
  //     averageExtraPrice
  //   );
  // };
  useEffect(() => {
    getPlotDetailsById(id)
  }, [])

  return (
    <div className='container-fluid landformconatiner p-4_' id="conatinerId">

      <div className='container-fluid landformconatiner p-4_'>

        <div className='container-fluid landformconatiner p-4'>

          <PageHeading pagename={"Define Sequencing"} />

          <div className='d-flex flex-column flex-md-row justify-content-between align-items-center'>

            <div className='d-flex flex-row justify-content-between align-items-center gap-2'>
              <PageHeading pagename={"Plot Area"} />
              <div className='pageheading'>
                <span>({plotSpecificationForm?.area ?? 0} SqrFt)</span>
              </div>
            </div>


            <div className='d-flex flex-row gap-2'>
              <PageHeading pagename={"Avg Plot Cost"} />
              <div className='pageheading'>
                <span>
                  ({Math.round(calculateAverageCost() * 100) / 100} ₹)
                </span>
              </div>
            </div>

            <div className='d-flex flex-row gap-2'>
              <PageHeading pagename={"Last Sequence Number :"} />
              <div className='pageheading'>
                <span>
                  {plotSpecificationForm?.[0]?.lastSequenceNumber}
                </span>
              </div>
            </div>

          </div>

          <div className='pt-2'>

            <div style={{ height: "68vh", overflow: "auto" }}>

              <table className="table">

                <thead>
                  <tr className='table-head'>
                    <th scope="col">Size</th>
                    <th scope="col">Plot Seq. No</th>
                    <th scope="col">Plot No</th>
                    <th scope="col">Is Commercial</th>
                    <th scope="col">Com. Extra Price (Per Sqft)</th>
                    <th scope="col">Plot Type</th>
                    <th scope="col">Extra Price (Per Sqft)</th>
                  </tr>
                </thead>

                <tbody className='table-body'>

                  {
                    sendForm && sendForm.map((val, ind) => {

                      return (

                        <tr key={ind}>

                          {/* <td>{val.dimensions}</td> */}
                          <td>      <input
                            type='text'
                            className='form-control'
                            name='plotdimmensions'
                            value={val.plotdimmensions}
                            onChange={(e) => handleChange(e, ind)}
                          /></td>

                          <td>
                            <input
                              type='number'
                              className='form-control'
                              name='plotSequenceNumber'
                              value={val.plotSequenceNumber}
                              onChange={(e) => handleChange(e, ind)}
                            />
                          </td>

                          <td>
                            <input
                              type='text'
                              className='form-control'
                              name='plotNumber'
                              value={val.plotNumber}
                              onChange={(e) => handleChange(e, ind)}
                            />
                          </td>

                          <td>
                            <input
                              type='checkbox'
                              name="isCommercial"
                              checked={val.isCommercial || false}
                              onChange={(e) => handleChange(e, ind)}
                            />
                          </td>
                          <td>
                            <input
                              type='number'
                              className='form-control'
                              name='extraPriceCommercial'
                              value={val.extraPriceCommercial}
                              onChange={(e) => handleChange(e, ind)}
                              disabled={!val.isCommercial}
                            />
                          </td>

                          <td>

                            {/* <div style={{
                              opacity: val.isCommercial ? 1 : 0.4,
                              pointerEvents: val.isCommercial ? "auto" : "none",
                              marginTop: "5px"
                            }}> */}
                            <label className="me-2">
                              <input
                                type="checkbox"
                                name="plotTypes"
                                value="1"
                                checked={val.plotTypes?.includes("1")}
                                onChange={(e) => handleChange(e, ind)}
                              /> Sea View
                            </label>

                            <label className="me-2">
                              <input
                                type="checkbox"
                                name="plotTypes"
                                value="2"
                                checked={val.plotTypes?.includes("2")}
                                onChange={(e) => handleChange(e, ind)}
                              /> River View
                            </label>

                            <label className="me-2">
                              <input
                                type="checkbox"
                                name="plotTypes"
                                value="3"
                                checked={val.plotTypes?.includes("3")}
                                onChange={(e) => handleChange(e, ind)}
                              /> Road Side
                            </label>

                            <label>
                              <input
                                type="checkbox"
                                name="plotTypes"
                                value="4"
                                checked={val.plotTypes?.includes("4")}
                                onChange={(e) => handleChange(e, ind)}
                              /> Corner
                            </label>

                            {/* </div> */}

                          </td>

                          <td>
                            <input
                              type='number'
                              className='form-control'
                              name='extraPrice'
                              value={val.extraPrice}
                              onChange={(e) => handleChange(e, ind)}
                              // disabled={!val.isCommercial}
                              disabled={!val.plotTypes || val.plotTypes.length === 0}
                            />
                          </td>

                        </tr>
                      )
                    })
                  }

                </tbody>

              </table>

            </div>

            <div className='d-flex flex-md-row justify-content-end me-5 gap-2'>

              {
                !isUpdate ?

                  <button
                    className='btn export-save-btn mt-4 h-50'
                    onClick={handleOnSave}
                  >
                    Save
                  </button>

                  :

                  <button
                    className='btn export-save-btn mt-4 h-50'
                    onClick={handleUpdate}
                  >
                    Update
                  </button>

              }
              <button
                className='btn export-save-btn mt-4 h-50'
                onClick={() => { window.history.back() }}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>

      <Loader show={loader} />

      {
        sideToaster.show === 1 ?

          <SideMessage
            close={setSideToaster}
            show={sideToaster.show}
            type={sideToaster.type}
            message={sideToaster.message}
          />

          : ""
      }

    </div>
  )
}